import React from 'react';
import Header from '../Header/Header';
import { Grid } from '@mui/material';
import BeableLogoWithName from '../../logo/BeableLogoWithName';

export default function NotFound() {
    return (
        <>
            <Header />
            <Grid
                container
                spacing={0}
                sx={{
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: '100vh'
                }}>
                <Grid size={3} sx={{
                    textAlign: "center"
                }}>
                    <BeableLogoWithName />
                    <br />
                    Page not found!
                </Grid>
            </Grid>
        </>
    );
}